module.exports = __webpack_public_path__ + "img/question-types.1f11f24a.png";